export type MessagingPurpose = 'customer_updates' | 'contractor_coordination' | 'recruiting' | 'staff_alerts';
export const MESSAGING_PURPOSES: Record<MessagingPurpose, string> = {
  customer_updates: 'Customer service and project updates',
  contractor_coordination: 'Contractor scheduling and coordination',
  recruiting: 'Job applications and interviews',
  staff_alerts: 'Staff operational alerts',
};
export interface MessagingReadiness {
  status: string; status_display: string; is_approved: boolean;
  messaging_purposes: MessagingPurpose[]; last_checked_at: string | null;
  can_send: boolean; reason: string;
}
export interface NumberQuote {
  phone_number: string; setup_fee: string; monthly_fee: string; total: string;
  quote_token: string; expires_at: string;
}
export interface NumberOperation {
  id: string; operation_key: string; kind: string; phone_number: string;
  status: string; error: string; created_at: string; finished_at: string | null;
}
export interface SMSDelivery {
  id: number; phone_number: string; purpose: MessagingPurpose; status: string;
  error: string; can_retry: boolean; sms_id: number | null;
  recipients: { type: string; id: number; name: string }[];
  attempts: { id: number; status: string; sent_at: string; error_message: string }[];
}
